/** @format */

import "../style/NotFoundPage.scss";
const NotFound = () => {
  return (
    <div className="canvas">
      <h3 className="titlen">OH JEEZ, IT'S A</h3>
      <h2 className="four1">4</h2>
      <h2 className="four">4</h2>
      <div className="morty">
        <div className="hair"></div>
        <div className="ears"></div>
        <div className="face"></div>
        <div className="eyes"></div>
        <div className="nose"></div>
        <div className="mouth"></div>
        <div className="lines"></div>
      </div>
      <h1 className="title2">ERROR</h1>
    </div>
  );
};
export default NotFound;
